import styled, { css } from 'styled-components';

import { Dropdown } from '@dreryk/react-components';

export const StyledConfidentialityNotificationsDropdown = styled(Dropdown)`
   &:not(:first-child) {
      margin-left: 8px;
   }

   span[name='label'] {
      overflow: inherit;
   }

   ${Dropdown.resolveFloatingNodeStyles(css`
      width: 400px;

      > div {
         max-height: 400px;
      }
   `)}
`;
StyledConfidentialityNotificationsDropdown.displayName = 'StyledConfidentialityNotificationsDropdown';

export const StyledNotificationDropdownItem = styled(Dropdown.Item)`
   &:hover {
      background: ${(props) => props.theme.backgroundLightest};
   }
`;
StyledNotificationDropdownItem.displayName = 'StyledNotificationDropdownItem';

export const StyledConfidentialityNotificationsTrigger = styled.span`
   position: relative;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   width: 24px;
   height: 24px;
   margin-top: 5px;
`;
StyledConfidentialityNotificationsTrigger.displayName = 'StyledConfidentialityNotificationsTrigger';
